// hooks/usePhoneMask.ts
import { useState, useCallback } from 'react'

interface PhoneMaskHook {
	// Текущие значения
	phoneCode: string
	phoneMask: string
	countryEN: string

	// Временные значения для модалки
	tempPhoneCode: string
	tempPhoneMask: string
	tempCountryEN: string

	// Состояние модалки
	isModalOpen: boolean

	// Методы
	openModal: () => void
	closeModal: () => void
	selectCountry: (country: { phone_code: string; phone_mask: string; name_en: string }) => void
	applySelection: () => void
	reset: () => void
}

export const usePhoneMask = (initialValues?: {
	phoneCode?: string
	phoneMask?: string
	countryEN?: string
}): PhoneMaskHook => {
	const [phoneCode, setPhoneCode] = useState(initialValues?.phoneCode || '7')
	const [phoneMask, setPhoneMask] = useState(initialValues?.phoneMask || '999 999 99 99')
	const [countryEN, setCountryEN] = useState(initialValues?.countryEN || 'Russia')

	const [tempPhoneCode, setTempPhoneCode] = useState(initialValues?.phoneCode || '7')
	const [tempPhoneMask, setTempPhoneMask] = useState(initialValues?.phoneMask || '999 999 99 99')
	const [tempCountryEN, setTempCountryEN] = useState(initialValues?.countryEN || 'Russia')

	const [isModalOpen, setIsModalOpen] = useState(false)

	const openModal = useCallback(() => {
		setTempPhoneCode(phoneCode)
		setTempPhoneMask(phoneMask)
		setTempCountryEN(countryEN)
		setIsModalOpen(true)
	}, [phoneCode, phoneMask, countryEN])

	const closeModal = useCallback(() => {
		setIsModalOpen(false)
	}, [])

	const selectCountry = useCallback((country: { phone_code: string; phone_mask: string; name_en: string }) => {
		setTempPhoneCode(country.phone_code)
		setTempPhoneMask(country.phone_mask)
		setTempCountryEN(country.name_en)
	}, [])

	const applySelection = useCallback(() => {
		setPhoneCode(tempPhoneCode)
		setPhoneMask(tempPhoneMask)
		setCountryEN(tempCountryEN)
		setIsModalOpen(false)
	}, [tempPhoneCode, tempPhoneMask, tempCountryEN])

	const reset = useCallback(() => {
		const defaults = {
			phoneCode: initialValues?.phoneCode || '7',
			phoneMask: initialValues?.phoneMask || '999 999 99 99',
			countryEN: initialValues?.countryEN || 'Russia',
		}

		setPhoneCode(defaults.phoneCode)
		setPhoneMask(defaults.phoneMask)
		setCountryEN(defaults.countryEN)
		setTempPhoneCode(defaults.phoneCode)
		setTempPhoneMask(defaults.phoneMask)
		setTempCountryEN(defaults.countryEN)
	}, [initialValues])

	return {
		phoneCode,
		phoneMask,
		countryEN,
		tempPhoneCode,
		tempPhoneMask,
		tempCountryEN,
		isModalOpen,
		openModal,
		closeModal,
		selectCountry,
		applySelection,
		reset,
	}
}
